import translations from './i18n';

// Extra translation keys for shell / lobby pages. All keys prefixed with sh_
// to avoid collisions with the core i18n.js keys. Six languages provided:
// th (Thai), en (English), zh (Simplified Chinese), ja (Japanese),
// my (Burmese), lo (Lao).
const ext = {
  th: {
    // Nav menu labels
    sh_nav_hotgame: 'ยอดนิยม',
    sh_nav_casino_trans: 'คาสิโนสด',
    sh_nav_casino_mobile: 'คาสิโน',
    sh_nav_slot_trans: 'สล็อตเกมส์',
    sh_nav_slot_mobile: 'สล็อต',
    sh_nav_sport: 'กีฬา',
    sh_nav_fishing: 'ยิงปลา',
    sh_nav_skillgame: 'สกิลเกมส์',
    sh_nav_esport: 'อีสปอร์ต',

    // Common UI
    sh_play_now: 'เข้าเล่น',

    // Headings / feed
    sh_heading_title: 'Ae sexy Casino คาสิโนออนไลน์ บาคาร่า ไฮโล เสือมังกร เว็บตรง Ae sexy',
    sh_feed_marquee: 'Ae sexy คาสิโนออนไลน์ สล็อตออนไลน์ ที่ให้คุณสนุกได้ทุกรูปแบบ',
    sh_subheading_full: 'Ae sexy Casino คาสิโนออนไลน์เต็มรูปแบบ ตื่นตาตื่นใจไปกับทุกการเดิมพัน',
    sh_recent_play: 'เล่นล่าสุด',
    sh_popular_casino: 'คาสิโนออนไลน์ ยอดนิยม',
    sh_popular_slot: 'สล็อตออนไลน์ ยอดนิยม',

    // Alerts
    sh_alert_game_problem: 'ขณะนี้เกมมีปัญหากรุณารอซักครู่',
    sh_alert_session_expired: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',

    // Pre-footer SEO content
    sh_pf_description: 'ให้บริการความสนุกไม่รู้จบ 24 ชม. ไปกับดีลเลอร์ “DEALER” สาวสวย สุดเซ็กซี่ คอยแจกไพ่ ให้คุณได้ลุ้นทุกเกมส์เดิมพัน สบายตา สบายใจ ด้วย สาวๆ น่ารัก สุดเซ็กซี่ มาใส่บิกินี่ แต่ละสีแต่ละวันสีสด มาแจกไพ่ ท่านจะได้รับประสบการณ์ใหม่ในการเดิมพัน',
    sh_pf_casino_for_all: 'คาสิโน สำหรับทุกคน',
    sh_pf_hilo_title: 'ไฮโล Hi-Low วางสูงต่ำ',
    sh_pf_hilo_paragraph: 'ซึ่งนอกจากบาคาร่าออนไลน์แล้วนั้นเว็บไซต์ของเรายังมีเกมการพนันอย่าง ไฮโลออนไลน์ ที่เป็นเกมการพนันพื้นบ้านที่ได้รับความนิยมจนต้องนำมาเพิ่มในคาสิโนออนไลน์ ซึ่ง ไฮโลออนไลน์ ของเราเล่นง่าย ได้เงินจริง คุณอาจจะรวยภายในข้ามคืนหากเดิมพันกับเว็บของเรา',
    sh_pf_roulette_title: 'รูเล็ต เล่นน้อยได้มาก พาคุณรวย',
    sh_pf_roulette_paragraph: 'เกมวงล้อนำโชคอย่าง รูเล็ตต์ ในเว็บไซต์ของเราได้นำสาวสวยมาหมุนวงล้อนำโชค ที่จะพาคุณรวยไปกับเกมสนุกสุดมันส์ ซึ่ง รูเล็ตต์ ในเว็บไซต์ของเรา คุณสามารถลงทุนน้อยแต่ได้กำไรมาก ให้เราเป็นส่วนนึงในความรวยของคุณ เพียงสมัครสมาชิกกับเรา',
    sh_pf_baccarat_title: 'บาคาร่าออนไลน์ เล่นเว็บตรง ที่นี่',
    sh_pf_baccarat_paragraph: 'สามารถเล่นเว็บตรงไม่ผ่านเอเย่นต์ได้ที่นี่ ด้วยความใส่ใจของเราจึงสามารถให้ลูกค้าเล่น บาคาร่าออนไลน์ และเกมการพนันอื่นๆ ได้ ที่นี่เป็นเว็บตรงไม่ต้องผ่านเอเย่นต์ทำให้สามารถเชื่อใจว่าไม่มีการโกงอย่างแน่นอน',
    sh_pf_dragontiger_title: 'เสือมังกร ลุ้นไว สนุก นิยมมาก',
    sh_pf_dragontiger_paragraph: 'ส่วนใครที่ชอบเกมเดิมพันไวๆ เรามีเกม เสือมังกร ที่สามารถรวยได้ง่ายๆ ในไม่กี่วินาที เป็นเกมคาสิโนออนไลน์อีกหนึ่งอย่างที่ได้รับความนิยมอย่างมากในเว็บของเรา หากใครที่ชอบความสนุกตื่นเต้น ที่มาพร้อมกับความรวยแนะนำให้ลองเล่นกับเรารับรองติดใจแน่นอน',
    sh_pf_bottom_description: 'เว็บอันดับหนึ่งที่รวมสาวสวยมากมายให้ท่านได้ตื่นตาตื่นใจ บาคาร่าออนไลน์ที่ เย้ายวนใจที่สุดในตอนนี้ หรือ ที่รู้จักกันว่า Sexy Baccarat, Sexy Gaming, เซ็กซี่เกมส์',
  },
  en: {
    sh_nav_hotgame: 'Popular',
    sh_nav_casino_trans: 'Live Casino',
    sh_nav_casino_mobile: 'Casino',
    sh_nav_slot_trans: 'Slot Games',
    sh_nav_slot_mobile: 'Slot',
    sh_nav_sport: 'Sport',
    sh_nav_fishing: 'Fishing',
    sh_nav_skillgame: 'Skill Game',
    sh_nav_esport: 'E-Sport',

    sh_play_now: 'Play Now',

    sh_heading_title: 'Ae sexy Casino - Online Casino, Baccarat, Hi-Lo, Dragon Tiger, Direct Website Ae sexy',
    sh_feed_marquee: 'Ae sexy online casino and online slots that let you enjoy every format of fun',
    sh_subheading_full: 'Ae sexy Casino - A full online casino, be amazed with every bet',
    sh_recent_play: 'Recently Played',
    sh_popular_casino: 'Popular Online Casino',
    sh_popular_slot: 'Popular Online Slots',

    sh_alert_game_problem: 'The game is currently having issues, please wait a moment',
    sh_alert_session_expired: 'Your session has expired, please log in again',

    sh_pf_description: 'Offering endless fun 24 hours a day with beautiful, sexy "DEALER" girls dealing cards, letting you thrill at every betting game. Easy on the eyes and relaxing, with cute, sexy girls in bikinis of a different bright color each day dealing the cards. You will get a brand new betting experience.',
    sh_pf_casino_for_all: 'Casino for Everyone',
    sh_pf_hilo_title: 'Hi-Lo, bet high or low',
    sh_pf_hilo_paragraph: 'Besides online baccarat, our website also offers gambling games such as online Hi-Lo, a popular local gambling game that we had to add to our online casino. Our online Hi-Lo is easy to play and pays real money. You could get rich overnight by betting with our website.',
    sh_pf_roulette_title: 'Roulette, play little win big, makes you rich',
    sh_pf_roulette_paragraph: 'Lucky wheel games like Roulette - on our website beautiful girls spin the lucky wheel that will make you rich with a thrilling, fun game. With Roulette on our website you can invest a little but earn big profits. Let us be a part of your wealth, just sign up with us.',
    sh_pf_baccarat_title: 'Online baccarat, play direct website here',
    sh_pf_baccarat_paragraph: 'You can play on a direct website without an agent right here. With our attentive care, we can let customers play online baccarat and other gambling games. This is a direct website without an agent, so you can trust that there is absolutely no cheating.',
    sh_pf_dragontiger_title: 'Dragon Tiger, fast thrills, very popular',
    sh_pf_dragontiger_paragraph: 'For those who like fast betting games, we have Dragon Tiger which can make you rich easily in just a few seconds. It is another online casino game that is very popular on our website. For anyone who likes fun and excitement that comes with wealth, we recommend giving it a try with us - you will surely be hooked.',
    sh_pf_bottom_description: 'The number one website that gathers many beautiful girls to amaze you, with the most alluring online baccarat right now, also known as Sexy Baccarat, Sexy Gaming, Sexy Games.',
  },
  zh: {
    sh_nav_hotgame: '热门',
    sh_nav_casino_trans: '真人娱乐场',
    sh_nav_casino_mobile: '娱乐场',
    sh_nav_slot_trans: '老虎机游戏',
    sh_nav_slot_mobile: '老虎机',
    sh_nav_sport: '体育',
    sh_nav_fishing: '捕鱼',
    sh_nav_skillgame: '技巧游戏',
    sh_nav_esport: '电子竞技',

    sh_play_now: '立即游戏',

    sh_heading_title: 'Ae sexy 娱乐场 - 在线娱乐场、百家乐、骰宝、龙虎，直营网站 Ae sexy',
    sh_feed_marquee: 'Ae sexy 在线娱乐场、在线老虎机，让您尽情享受各种乐趣',
    sh_subheading_full: 'Ae sexy 娱乐场 - 全方位在线娱乐场，为每一次投注而惊喜',
    sh_recent_play: '最近游玩',
    sh_popular_casino: '热门在线娱乐场',
    sh_popular_slot: '热门在线老虎机',

    sh_alert_game_problem: '游戏目前出现问题，请稍候片刻',
    sh_alert_session_expired: '您的会话已过期，请重新登录',

    sh_pf_description: '全天24小时提供无尽乐趣，由美丽性感的"荷官"为您发牌，让您在每一场投注游戏中尽情期待。赏心悦目、轻松愉快，可爱性感的女孩每天穿着不同鲜艳颜色的比基尼为您发牌。您将获得全新的投注体验。',
    sh_pf_casino_for_all: '人人皆宜的娱乐场',
    sh_pf_hilo_title: '骰宝，押大押小',
    sh_pf_hilo_paragraph: '除了在线百家乐外，我们的网站还提供在线骰宝等博彩游戏，这是一款广受欢迎的本地博彩游戏，我们不得不将其加入在线娱乐场。我们的在线骰宝简单易玩，可赢取真钱。在我们的网站投注，您也许一夜致富。',
    sh_pf_roulette_title: '轮盘，小投入大回报，让您致富',
    sh_pf_roulette_paragraph: '轮盘等幸运转盘游戏，在我们的网站上由美丽女孩转动幸运转盘，将通过刺激有趣的游戏让您致富。在我们网站玩轮盘，您可以小额投入却赢得丰厚利润。让我们成为您财富的一部分，只需注册成为会员。',
    sh_pf_baccarat_title: '在线百家乐，在此玩直营网站',
    sh_pf_baccarat_paragraph: '您可以在此直接在直营网站游玩，无需通过代理。凭借我们的用心，可以让客户畅玩在线百家乐及其他博彩游戏。这是无需代理的直营网站，您可以放心绝无作弊。',
    sh_pf_dragontiger_title: '龙虎，快速期待，乐趣十足，广受欢迎',
    sh_pf_dragontiger_paragraph: '对于喜欢快速投注游戏的人，我们有龙虎，可以在短短几秒内轻松致富。这是另一款在我们网站非常受欢迎的在线娱乐场游戏。对于喜欢伴随财富的乐趣与刺激的人，我们推荐您与我们一起试玩，保证让您欲罢不能。',
    sh_pf_bottom_description: '汇集众多美丽女孩让您惊艳的第一网站，拥有当下最迷人的在线百家乐，也被称为 Sexy Baccarat、Sexy Gaming、性感游戏。',
  },
  ja: {
    sh_nav_hotgame: '人気',
    sh_nav_casino_trans: 'ライブカジノ',
    sh_nav_casino_mobile: 'カジノ',
    sh_nav_slot_trans: 'スロットゲーム',
    sh_nav_slot_mobile: 'スロット',
    sh_nav_sport: 'スポーツ',
    sh_nav_fishing: 'フィッシング',
    sh_nav_skillgame: 'スキルゲーム',
    sh_nav_esport: 'eスポーツ',

    sh_play_now: 'プレイする',

    sh_heading_title: 'Ae sexy カジノ - オンラインカジノ、バカラ、ハイロー、ドラゴンタイガー、公式サイト Ae sexy',
    sh_feed_marquee: 'Ae sexy オンラインカジノ・オンラインスロットで、あらゆる楽しみを満喫できます',
    sh_subheading_full: 'Ae sexy カジノ - 本格オンラインカジノ、すべてのベットで驚きを',
    sh_recent_play: '最近プレイした',
    sh_popular_casino: '人気オンラインカジノ',
    sh_popular_slot: '人気オンラインスロット',

    sh_alert_game_problem: '現在ゲームに問題が発生しています。少々お待ちください',
    sh_alert_session_expired: 'セッションの有効期限が切れました。再度ログインしてください',

    sh_pf_description: '24時間、美しくセクシーな「DEALER」の女性たちがカードを配り、終わりのない楽しさを提供します。すべてのベットゲームでスリルを味わえます。目に優しくリラックスでき、可愛くセクシーな女の子たちが日替わりで鮮やかな色のビキニを着てカードを配ります。あなたは全く新しいベット体験を得られるでしょう。',
    sh_pf_casino_for_all: 'みんなのためのカジノ',
    sh_pf_hilo_title: 'ハイロー、ハイかローにベット',
    sh_pf_hilo_paragraph: 'オンラインバカラに加え、当サイトではオンラインハイローなどのギャンブルゲームも提供しています。人気の地元ギャンブルゲームで、オンラインカジノに追加せざるを得ませんでした。当サイトのオンラインハイローは遊びやすく、本物のお金を稼げます。当サイトでベットすれば一夜で裕福になれるかもしれません。',
    sh_pf_roulette_title: 'ルーレット、少なく賭けて大きく勝ち、富をもたらす',
    sh_pf_roulette_paragraph: 'ルーレットのようなラッキーホイールゲームでは、当サイトで美しい女の子たちがラッキーホイールを回し、スリリングで楽しいゲームで富をもたらします。当サイトのルーレットなら、少ない投資で大きな利益を得られます。私たちをあなたの富の一部にしてください。会員登録するだけです。',
    sh_pf_baccarat_title: 'オンラインバカラ、公式サイトでここでプレイ',
    sh_pf_baccarat_paragraph: 'エージェントを介さず、ここで公式サイトを直接プレイできます。私たちの細やかな配慮により、お客様にオンラインバカラやその他のギャンブルゲームをお楽しみいただけます。これはエージェント不要の公式サイトなので、不正は一切ないと信頼できます。',
    sh_pf_dragontiger_title: 'ドラゴンタイガー、素早いスリル、大人気',
    sh_pf_dragontiger_paragraph: '素早いベットゲームが好きな方には、わずか数秒で簡単に裕福になれるドラゴンタイガーがあります。当サイトで非常に人気のあるもう一つのオンラインカジノゲームです。富とともに訪れる楽しさと興奮が好きな方は、ぜひ私たちと一緒にお試しください。きっと夢中になります。',
    sh_pf_bottom_description: '多くの美しい女の子を集めてあなたを魅了するナンバーワンサイト。今最も魅惑的なオンラインバカラ、Sexy Baccarat、Sexy Gaming、セクシーゲームとしても知られています。',
  },
  my: {
    sh_nav_hotgame: 'လူကြိုက်များ',
    sh_nav_casino_trans: 'တိုက်ရိုက်ကာစီနို',
    sh_nav_casino_mobile: 'ကာစီနို',
    sh_nav_slot_trans: 'စလော့ဂိမ်းများ',
    sh_nav_slot_mobile: 'စလော့',
    sh_nav_sport: 'အားကစား',
    sh_nav_fishing: 'ငါးပစ်ခြင်း',
    sh_nav_skillgame: 'ကျွမ်းကျင်မှုဂိမ်း',
    sh_nav_esport: 'အီးစပို့',

    sh_play_now: 'ယခုကစားရန်',

    sh_heading_title: 'Ae sexy ကာစီနို - အွန်လိုင်းကာစီနို၊ ဘာကာရာ၊ Hi-Lo၊ နဂါးကျား၊ တိုက်ရိုက်ဝဘ်ဆိုက် Ae sexy',
    sh_feed_marquee: 'Ae sexy အွန်လိုင်းကာစီနိုနှင့် အွန်လိုင်းစလော့များ၊ ပုံစံတိုင်းဖြင့် ပျော်ရွှင်စေပါသည်',
    sh_subheading_full: 'Ae sexy ကာစီနို - ပြည့်စုံသော အွန်လိုင်းကာစီနို၊ လောင်းကြေးတိုင်းတွင် အံ့သြစေပါ',
    sh_recent_play: 'မကြာသေးမီကစားခဲ့သည်',
    sh_popular_casino: 'လူကြိုက်များသော အွန်လိုင်းကာစီနို',
    sh_popular_slot: 'လူကြိုက်များသော အွန်လိုင်းစလော့',

    sh_alert_game_problem: 'ဂိမ်းတွင် ယခုပြဿနာရှိနေပါသည်၊ ခဏစောင့်ပါ',
    sh_alert_session_expired: 'သင့်စက်ရှင် သက်တမ်းကုန်သွားပါပြီ၊ ကျေးဇူးပြု၍ ပြန်လည်ဝင်ရောက်ပါ',

    sh_pf_description: 'နေ့စဉ် ၂၄ နာရီ အဆုံးမရှိသော ပျော်ရွှင်မှုကို လှပ၍ဆွဲဆောင်မှုရှိသော "DEALER" မိန်းကလေးများက ဖဲဝေပေးခြင်းဖြင့် ဝန်ဆောင်မှုပေးပါသည်။ လောင်းကြေးဂိမ်းတိုင်းတွင် စိတ်လှုပ်ရှားစွာ စောင့်မျှော်နိုင်ပါသည်။ ချစ်စရာကောင်း၍ ဆွဲဆောင်မှုရှိသော မိန်းကလေးများက နေ့စဉ်အရောင်အသွေးစုံ ဘီကီနီများဝတ်ဆင်ကာ ဖဲဝေပေးခြင်းဖြင့် မျက်စိအေးချမ်းစေပါသည်။ သင်သည် လောင်းကြေးအတွေ့အကြုံအသစ်ကို ရရှိပါလိမ့်မည်။',
    sh_pf_casino_for_all: 'လူတိုင်းအတွက် ကာစီနို',
    sh_pf_hilo_title: 'Hi-Lo၊ အမြင့်အနိမ့် လောင်းကြေး',
    sh_pf_hilo_paragraph: 'အွန်လိုင်းဘာကာရာအပြင် ကျွန်ုပ်တို့၏ဝဘ်ဆိုက်တွင် အွန်လိုင်း Hi-Lo ကဲ့သို့သော လောင်းကစားဂိမ်းများလည်း ရှိပါသည်။ ၎င်းသည် လူကြိုက်များသော ဒေသခံလောင်းကစားဂိမ်းဖြစ်ပြီး အွန်လိုင်းကာစီနိုတွင် ထည့်သွင်းရန် လိုအပ်ခဲ့ပါသည်။ ကျွန်ုပ်တို့၏ အွန်လိုင်း Hi-Lo သည် ကစားရလွယ်ကူ၍ ငွေအစစ်ရရှိပါသည်။ ကျွန်ုပ်တို့ဝဘ်ဆိုက်တွင် လောင်းကြေးထပ်ပါက တစ်ညအတွင်း ချမ်းသာသွားနိုင်ပါသည်။',
    sh_pf_roulette_title: 'ရူးလက်၊ နည်းနည်းကစား များများရ၊ သင့်ကိုချမ်းသာစေသည်',
    sh_pf_roulette_paragraph: 'ရူးလက်ကဲ့သို့သော ကံကောင်းခွက်ဂိမ်းများတွင် ကျွန်ုပ်တို့ဝဘ်ဆိုက်၌ လှပသောမိန်းကလေးများက ကံကောင်းခွက်ကိုလှည့်ပြီး စိတ်လှုပ်ရှားဖွယ်ပျော်ရွှင်ဖွယ်ဂိမ်းဖြင့် သင့်ကိုချမ်းသာစေပါမည်။ ကျွန်ုပ်တို့ဝဘ်ဆိုက်ရှိ ရူးလက်တွင် အနည်းငယ်ရင်းနှီးပြီး အမြတ်များများ ရရှိနိုင်ပါသည်။ သင့်ချမ်းသာမှု၏ အစိတ်အပိုင်းတစ်ခုဖြစ်ခွင့်ပေးပါ၊ ကျွန်ုပ်တို့နှင့် အသင်းဝင်လိုက်ရုံပါပဲ။',
    sh_pf_baccarat_title: 'အွန်လိုင်းဘာကာရာ၊ တိုက်ရိုက်ဝဘ်ဆိုက်ကို ဤနေရာတွင်ကစားပါ',
    sh_pf_baccarat_paragraph: 'ကိုယ်စားလှယ်မလိုဘဲ တိုက်ရိုက်ဝဘ်ဆိုက်ကို ဤနေရာတွင် ကစားနိုင်ပါသည်။ ကျွန်ုပ်တို့၏ ဂရုစိုက်မှုဖြင့် ဖောက်သည်များကို အွန်လိုင်းဘာကာရာနှင့် အခြားလောင်းကစားဂိမ်းများ ကစားခွင့်ပေးနိုင်ပါသည်။ ဤသည်မှာ ကိုယ်စားလှယ်မလိုသော တိုက်ရိုက်ဝဘ်ဆိုက်ဖြစ်၍ လိမ်လည်မှုလုံးဝမရှိကြောင်း ယုံကြည်နိုင်ပါသည်။',
    sh_pf_dragontiger_title: 'နဂါးကျား၊ မြန်ဆန်စိတ်လှုပ်ရှား၊ အလွန်လူကြိုက်များ',
    sh_pf_dragontiger_paragraph: 'မြန်ဆန်သော လောင်းကြေးဂိမ်းများကို နှစ်သက်သူများအတွက် စက္ကန့်အနည်းငယ်အတွင်း လွယ်ကူစွာချမ်းသာနိုင်သော နဂါးကျား ရှိပါသည်။ ၎င်းသည် ကျွန်ုပ်တို့ဝဘ်ဆိုက်တွင် အလွန်လူကြိုက်များသော နောက်ထပ်အွန်လိုင်းကာစီနိုဂိမ်းတစ်ခုဖြစ်ပါသည်။ ချမ်းသာမှုနှင့်အတူ ပျော်ရွှင်စိတ်လှုပ်ရှားမှုကို နှစ်သက်သူများအတွက် ကျွန်ုပ်တို့နှင့် စမ်းကစားရန် အကြံပြုပါသည်၊ သေချာပေါက် စွဲလမ်းသွားပါလိမ့်မည်။',
    sh_pf_bottom_description: 'သင့်ကိုအံ့သြစေရန် လှပသောမိန်းကလေးများစွာကို စုစည်းထားသော နံပါတ်တစ်ဝဘ်ဆိုက်၊ ယခုအဆွဲဆောင်ဆုံး အွန်လိုင်းဘာကာရာ၊ Sexy Baccarat, Sexy Gaming, Sexy Games ဟုလည်း လူသိများပါသည်။',
  },
  lo: {
    sh_nav_hotgame: 'ນິຍົມ',
    sh_nav_casino_trans: 'ຄາສິໂນສົດ',
    sh_nav_casino_mobile: 'ຄາສິໂນ',
    sh_nav_slot_trans: 'ເກມສະລັອດ',
    sh_nav_slot_mobile: 'ສະລັອດ',
    sh_nav_sport: 'ກິລາ',
    sh_nav_fishing: 'ຍິງປາ',
    sh_nav_skillgame: 'ເກມສະກິນ',
    sh_nav_esport: 'ອີສະປອດ',

    sh_play_now: 'ເຂົ້າຫຼິ້ນ',

    sh_heading_title: 'Ae sexy Casino - ຄາສິໂນອອນລາຍ, ບາກາຣາ, ໄຮໂລ, ເສືອມັງກອນ, ເວັບໂດຍກົງ Ae sexy',
    sh_feed_marquee: 'Ae sexy ຄາສິໂນອອນລາຍ ສະລັອດອອນລາຍ ທີ່ໃຫ້ທ່ານມ່ວນຊື່ນໄດ້ທຸກຮູບແບບ',
    sh_subheading_full: 'Ae sexy Casino ຄາສິໂນອອນລາຍເຕັມຮູບແບບ ຕື່ນຕາຕື່ນໃຈໄປກັບທຸກການເດີມພັນ',
    sh_recent_play: 'ຫຼິ້ນຫຼ້າສຸດ',
    sh_popular_casino: 'ຄາສິໂນອອນລາຍ ນິຍົມ',
    sh_popular_slot: 'ສະລັອດອອນລາຍ ນິຍົມ',

    sh_alert_game_problem: 'ຂະນະນີ້ເກມມີບັນຫາ ກະລຸນາລໍຖ້າຄາວໜຶ່ງ',
    sh_alert_session_expired: 'Session ຂອງທ່ານໝົດອາຍຸ ກະລຸນາ login ເຂົ້າສູ່ລະບົບອີກຄັ້ງ',

    sh_pf_description: 'ໃຫ້ບໍລິການຄວາມມ່ວນຊື່ນບໍ່ຮູ້ຈົບ 24 ຊມ. ໄປກັບດີລເລີ "DEALER" ສາວງາມ ສຸດເຊັກຊີ່ ຄອຍແຈກໄພ່ ໃຫ້ທ່ານໄດ້ລຸ້ນທຸກເກມເດີມພັນ ສະບາຍຕາ ສະບາຍໃຈ ດ້ວຍ ສາວໆ ໜ້າຮັກ ສຸດເຊັກຊີ່ ໃສ່ບີກີນີ່ ແຕ່ລະສີແຕ່ລະວັນສີສົດ ມາແຈກໄພ່ ທ່ານຈະໄດ້ຮັບປະສົບການໃໝ່ໃນການເດີມພັນ',
    sh_pf_casino_for_all: 'ຄາສິໂນ ສຳລັບທຸກຄົນ',
    sh_pf_hilo_title: 'ໄຮໂລ Hi-Low ວາງສູງຕ່ຳ',
    sh_pf_hilo_paragraph: 'ເຊິ່ງນອກຈາກບາກາຣາອອນລາຍແລ້ວນັ້ນ ເວັບໄຊຂອງເຮົາຍັງມີເກມການພະນັນຢ່າງ ໄຮໂລອອນລາຍ ທີ່ເປັນເກມການພະນັນພື້ນບ້ານທີ່ໄດ້ຮັບຄວາມນິຍົມຈົນຕ້ອງນຳມາເພີ່ມໃນຄາສິໂນອອນລາຍ ເຊິ່ງ ໄຮໂລອອນລາຍ ຂອງເຮົາຫຼິ້ນງ່າຍ ໄດ້ເງິນຈິງ ທ່ານອາດຈະລວຍພາຍໃນຂ້າມຄືນຫາກເດີມພັນກັບເວັບຂອງເຮົາ',
    sh_pf_roulette_title: 'ຣູເລັດ ຫຼິ້ນໜ້ອຍໄດ້ຫຼາຍ ພາທ່ານລວຍ',
    sh_pf_roulette_paragraph: 'ເກມວົງລໍ້ນຳໂຊກຢ່າງ ຣູເລັດ ໃນເວັບໄຊຂອງເຮົາໄດ້ນຳສາວງາມມາໝູນວົງລໍ້ນຳໂຊກ ທີ່ຈະພາທ່ານລວຍໄປກັບເກມມ່ວນສຸດມັນ ເຊິ່ງ ຣູເລັດ ໃນເວັບໄຊຂອງເຮົາ ທ່ານສາມາດລົງທຶນໜ້ອຍແຕ່ໄດ້ກຳໄລຫຼາຍ ໃຫ້ເຮົາເປັນສ່ວນໜຶ່ງໃນຄວາມລວຍຂອງທ່ານ ພຽງສະໝັກສະມາຊິກກັບເຮົາ',
    sh_pf_baccarat_title: 'ບາກາຣາອອນລາຍ ຫຼິ້ນເວັບໂດຍກົງ ທີ່ນີ້',
    sh_pf_baccarat_paragraph: 'ສາມາດຫຼິ້ນເວັບໂດຍກົງບໍ່ຜ່ານຕົວແທນໄດ້ທີ່ນີ້ ດ້ວຍຄວາມໃສ່ໃຈຂອງເຮົາຈຶ່ງສາມາດໃຫ້ລູກຄ້າຫຼິ້ນ ບາກາຣາອອນລາຍ ແລະເກມການພະນັນອື່ນໆ ໄດ້ ທີ່ນີ້ເປັນເວັບໂດຍກົງບໍ່ຕ້ອງຜ່ານຕົວແທນ ເຮັດໃຫ້ສາມາດເຊື່ອໃຈວ່າບໍ່ມີການໂກງຢ່າງແນ່ນອນ',
    sh_pf_dragontiger_title: 'ເສືອມັງກອນ ລຸ້ນໄວ ມ່ວນ ນິຍົມຫຼາຍ',
    sh_pf_dragontiger_paragraph: 'ສ່ວນໃຜທີ່ມັກເກມເດີມພັນໄວໆ ເຮົາມີເກມ ເສືອມັງກອນ ທີ່ສາມາດລວຍໄດ້ງ່າຍໆ ໃນບໍ່ກີ່ວິນາທີ ເປັນເກມຄາສິໂນອອນລາຍອີກໜຶ່ງຢ່າງທີ່ໄດ້ຮັບຄວາມນິຍົມຢ່າງຫຼາຍໃນເວັບຂອງເຮົາ ຫາກໃຜທີ່ມັກຄວາມມ່ວນຕື່ນເຕັ້ນ ທີ່ມາພ້ອມກັບຄວາມລວຍ ແນະນຳໃຫ້ລອງຫຼິ້ນກັບເຮົາ ຮັບຮອງຕິດໃຈແນ່ນອນ',
    sh_pf_bottom_description: 'ເວັບອັນດັບໜຶ່ງທີ່ລວມສາວງາມຫຼາຍມາຍໃຫ້ທ່ານໄດ້ຕື່ນຕາຕື່ນໃຈ ບາກາຣາອອນລາຍທີ່ ເຍົ້າຍວນໃຈທີ່ສຸດໃນຕອນນີ້ ຫຼື ທີ່ຮູ້ຈັກກັນວ່າ Sexy Baccarat, Sexy Gaming, ເຊັກຊີ່ເກມ',
  },
};
Object.keys(ext).forEach((l) => { translations[l] = Object.assign({}, translations[l], ext[l]); });
export default ext;
